'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _ExtendedButton = require('./ExtendedButton');

var _ExtendedButton2 = _interopRequireDefault(_ExtendedButton);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Textfield = require('./Textfield');

var _Textfield2 = _interopRequireDefault(_Textfield);

var _DateField = require('./DateField');

var _DateField2 = _interopRequireDefault(_DateField);

var _MessageBox = require('./MessageBox');

var _MessageBox2 = _interopRequireDefault(_MessageBox);

var _utilsLib = require('utils-lib');

var _Vas = require('../Vas');

var _Vas2 = _interopRequireDefault(_Vas);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var moment = require('moment');
moment().format();

// eslint-disable-next-line react/prefer-stateless-function

var ConfirmationFields = function (_Component) {
  _inherits(ConfirmationFields, _Component);

  function ConfirmationFields(props) {
    _classCallCheck(this, ConfirmationFields);

    var _this = _possibleConstructorReturn(this, (ConfirmationFields.__proto__ || Object.getPrototypeOf(ConfirmationFields)).call(this, props));

    _this.state = {};
    _this.state.C = _this.props.C;
    _this.state.ExistConfirm = [];
    _this.state.ContractStart = _this.props.ContractStart;
    _this.state.Id = _this.props.Id ? _this.props.Id : _this.state.C ? "ConfirmationField" + _this.state.C["Name"] : "ConfirmationField";
    _this.state.requestFiles = [];
    _this.textInput = _react2.default.createRef();
    return _this;
  }

  _createClass(ConfirmationFields, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.textInput.current.focus();
    }
  }, {
    key: 'getRequestFiles',
    value: function getRequestFiles() {
      return this.state.requestFiles;
    }
  }, {
    key: 'removeCertificate',
    value: function removeCertificate(key) {
      if (key !== undefined) {
        var cur = [];
        cur = this.state.requestFiles;
        for (var i = 0; i < cur.length; i++) {
          if (cur[i].Key === key) {
            cur.splice(i, 1);
            break;
          }
        }

        var exist = [];
        exist = this.state.ExistConfirm;

        for (var _i = 0; _i < exist.length; _i++) {
          if (exist[_i].Key === key) {
            exist.splice(_i, 1);
            break;
          }
        }

        this.setState({ requestFiles: cur, ExistConfirm: exist });
      } else {
        var _exist = [];
        _exist = this.state.ExistConfirm;

        for (var _i2 = 0; _i2 < _exist.length; _i2++) {
          if (_exist[_i2].Name === "Coupon-Code") {
            _exist.splice(_i2, 1);
            break;
          }
        }
        this.setState({ CouponCode: undefined, ExistConfirm: _exist });
      }
    }
  }, {
    key: 'uploadDocument',
    value: function uploadDocument(C) {
      var curContractStart = _utilsLib.DateTimeHelper.StringToDate(this.state.ContractStart, false, localStorage.getItem('vas_language'));
      var start = curContractStart;

      var ok = false;
      var falseDate = false;
      var formData = new FormData();
      var fileName = '';
      if (C.CouponCode === false) {
        if (this.state.files) {
          for (var i = 0; i < this.state.files.length; i++) {
            formData.append("file", this.state.files[i], this.state.files[i].name);
            fileName = this.state.files[i].name;
            ok = true;
          }
        }
      } else {
        ok = true;
      }
      formData.append("customerId", this.CustomerId);

      formData.append("confirmationId", C.Ident);

      if (ok === true) {
        if (C.DateFrom === true) {
          if (this.state.CertificateStart) {
            var cur = _utilsLib.DateTimeHelper.StringToDate(this.state.CertificateStart, false, localStorage.getItem('vas_language'));
            var certStart = cur;

            if (certStart.isSameOrBefore(start) === true) {
              formData.append("datefrom", moment([cur.year(), cur.month(), cur.date()]).format("YYYY-MM-DD T 00:00:00"));
              ok = true;
            } else {
              ok = false;
              falseDate = true;
            }
          } else {
            ok = false;
          }
        } else {
          formData.append("datefrom", null);
        }
      }

      if (ok === true) {
        if (C.DateTo === true) {
          if (this.state.CertificateEnd) {
            var _cur = _utilsLib.DateTimeHelper.StringToDate(this.state.CertificateEnd, false, localStorage.getItem('vas_language'));
            var certEnd = _cur;

            if (certEnd.isSameOrAfter(start) === true) {
              formData.append("dateto", moment([_cur.year(), _cur.month(), _cur.date()]).format("YYYY-MM-DD T 00:00:00"));
              ok = true;
            } else {
              ok = false;
              falseDate = true;
            }
          } else {
            ok = false;
          }
        } else {
          formData.append("dateto", null);
        }
      }

      if (ok === true) {
        if (C.IdentificationNumber === true) {
          if (this.state.IdentificationNumber) {
            formData.append("identificationNumber", this.state.IdentificationNumber);
            ok = true;
          } else {
            ok = false;
          }
        } else {
          formData.append("identificationNumber", null);
        }
      }

      if (ok === true) {
        if (C.CouponCode === true) {
          if (this.state.CouponCode) {
            formData.append("couponCode", this.state.CouponCode);
            ok = true;
          } else {
            ok = false;
          }
        } else {
          formData.append("couponCode", null);
        }
      }

      if (ok === true) {
        if (C.CouponCode === false) {
          var _cur2 = [];
          _cur2 = this.state.requestFiles;
          _cur2.push({ Formdata: formData, Key: C.Name + fileName });
          var exist = [];
          exist = this.state.ExistConfirm;
          exist.push({ Name: C.Name, CouponCode: false, VAS: false, FileName: fileName, Key: C.Name + fileName });
          this.setState({ requestFiles: _cur2, ExistConfirm: exist });
          this.setState({ CertificationType: null, CertificateStart: null, CertificateEnd: null, IdentificationNumber: null, requiredFieldsCertificate: null, files: null, fileName: '' });
          (0, _jquery2.default)('#uploadFields' + this.state.Id).removeClass().addClass('uploadFields');
          _reactDom2.default.unmountComponentAtNode(document.getElementById('uploadFields' + this.state.Id));

          /*  Request.ajax(null, false, true, "/Confirmations", "POST", formData, false, false,
                function (response) {
                    me.setState({ CertificationType: null, CertificateStart: null, CertificateEnd: null, IdentificationNumber: null, CouponCode: null, requiredFieldsCertificate: null, files: null, fileName: '' });
                    $('#uploadFields').removeClass().addClass('uploadFields');
                    ReactDOM.unmountComponentAtNode(document.getElementById('uploadFields'));
                    me.getConfirmationFields();
                }, null, true);*/
        } else {
          (0, _jquery2.default)('#uploadFields' + this.state.Id).removeClass().addClass('uploadFields');
          _reactDom2.default.unmountComponentAtNode(document.getElementById('uploadFields' + this.state.Id));
          (0, _jquery2.default)("#LoadingIconPopUp").removeClass().addClass('hide');
        }
      } else {
        if (falseDate === true) {
          _reactDom2.default.render(_react2.default.createElement(_MessageBox2.default, {
            AppURL: _Vas2.default.ApplicationUrl,
            Title: _Vas2.default.getText("Titles", "Note"),
            Message: _Vas2.default.getText("Labels", "FalseDate") }), document.getElementById('messageContainer'));
        } else {
          _reactDom2.default.render(_react2.default.createElement(_MessageBox2.default, {
            AppURL: _Vas2.default.ApplicationUrl,
            Title: _Vas2.default.getText("Titles", "Note"),
            Message: _Vas2.default.getText("Labels", "NotAllFields") }), document.getElementById('messageContainer'));
        }
      }
    }
  }, {
    key: 'storeFile',
    value: function storeFile(event, C) {
      var _this2 = this;

      if (event) {
        if (event.target) {
          if (event.target.files) {
            if (event.target.files[0]) {
              var type = event.target.files[0].type;

              var maxFileSize = localStorage.getItem("MaxFileSize") * 1024;

              if (event.target.files[0].size > maxFileSize) {
                alert('Die von Ihnen gewählte Datei ist zu groß. \nSie darf maximal ' + localStorage.getItem("MaxFileSize") / 1024 + ' MB groß sein.');
              } else {
                if (type.slice(0, 5) === "image" || type === "application/pdf" || type === "application/msword" || type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
                  if (this.state.FileText) {
                    this.state.FileText.setState({ Value: event.target.files[0].name });
                  }
                  this.setState({ files: event.target.files, fileName: event.target.files[0].name }, function () {
                    //this.getUploadFileds(C);
                    _this2.uploadDocument(C);
                  });
                }
              }
            }
          }
        }
      }
    }
  }, {
    key: 'getUploadFileds',
    value: function getUploadFileds(C) {
      var _this3 = this;

      // lege Felder für das hochladen eines Nachweises fest

      var from = _react2.default.createElement('td', null);
      var to = _react2.default.createElement('td', null);
      var id = _react2.default.createElement('td', null);
      var couponCode = '';

      (0, _jquery2.default)('#uploadFields' + this.state.Id).removeClass().addClass('uploadFieldsVisible');

      if (C["DateFrom"] === true) {
        from = _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(_DateField2.default, {
            AppURL: _Vas2.default.ApplicationUrl,
            ChooseDataText: _Vas2.default.getText("Labels", "ChooseDate"),
            Language: localStorage.getItem("vas_language"),
            Width: 200,
            Editable: true,
            IsRequired: true,
            Id: "CertificateStart",
            Label: _Vas2.default.getText("Labels", "ValidFrom") + '*',
            OnBlur: function OnBlur() {
              _this3.setState({ CertificateStart: (0, _jquery2.default)("#CertificateStart").val() });
            },
            FalseDateText: _Vas2.default.getText("Labels", "DateNotValid"),
            FalseDateTitle: _Vas2.default.getText("Titles", "Note")
          })
        );
      }

      if (C["DateTo"] === true) {
        to = _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(_DateField2.default, {
            AppURL: _Vas2.default.ApplicationUrl,
            ChooseDataText: _Vas2.default.getText("Labels", "ChooseDate"),
            Language: localStorage.getItem("vas_language"),
            Width: 200,
            Editable: true,
            IsRequired: true,
            Id: "CertificateEnd",
            Label: _Vas2.default.getText("Labels", "ValidTo") + '*',
            OnBlur: function OnBlur() {
              _this3.setState({ CertificateEnd: (0, _jquery2.default)("#CertificateEnd").val() });
            },
            FalseDateText: _Vas2.default.getText("Labels", "DateNotValid"),
            FalseDateTitle: _Vas2.default.getText("Titles", "Note")
          })
        );
      }

      if (C["IdentificationNumber"] === true) {
        id = _react2.default.createElement(
          'td',
          { colSpan: 2 },
          _react2.default.createElement(_Textfield2.default, {
            AppURL: _Vas2.default.ApplicationUrl,
            Width: 220,
            Id: 'IDField',
            Editable: true,
            IsRequired: true,
            Label: _Vas2.default.getText("Labels", "IdentificationNumber") + '*',
            OnBlur: function OnBlur() {
              _this3.setState({ IdentificationNumber: (0, _jquery2.default)("#IDField").val() });
            } })
        );
      }

      if (C["CouponCode"] === true) {

        if (document.getElementById('CouponCodeField') != null) {
          document.getElementById('CouponCodeField').value = '';
        }

        couponCode = _react2.default.createElement(
          'table',
          null,
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                { colSpan: 2 },
                _react2.default.createElement(_Textfield2.default, {
                  AppURL: _Vas2.default.ApplicationUrl,
                  Width: 220,
                  Id: 'CouponCodeField',
                  Editable: true,
                  IsRequired: true,
                  Label: _Vas2.default.getText("Labels", "CouponCode") + '*',
                  OnBlur: function OnBlur() {
                    _this3.setState({ CouponCode: (0, _jquery2.default)("#CouponCodeField").val() });
                  } })
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(_ExtendedButton2.default, {
                  Usable: true,
                  Text: _Vas2.default.getText("Labels", "ConfirmCouponCode"),
                  Float: "left",
                  Width: 220,
                  OnClick: function OnClick() {
                    _this3.checkCode(C);
                  } })
              )
            )
          )
        );
      }

      var FileText = void 0;

      if (couponCode === '') {
        if (C["Name"] === "Lichtbild") {

          _reactDom2.default.render(_react2.default.createElement(
            'table',
            null,
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { colSpan: 2 },
                  _react2.default.createElement(_Textfield2.default, {
                    AppURL: _Vas2.default.ApplicationUrl,
                    Value: C["Name"],
                    Width: 220,
                    Id: "Text",
                    Editable: false,
                    Label: _Vas2.default.getText("Labels", "CertificationType") })
                )
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(
                    'div',
                    { style: { margin: '10px', fileSize: '14px' } },
                    _react2.default.createElement(
                      'b',
                      null,
                      _Vas2.default.getText("Titles", "Note"),
                      ': '
                    ),
                    _react2.default.createElement(
                      'i',
                      null,
                      C["Description"]
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'tr',
                null,
                from
              ),
              _react2.default.createElement(
                'tr',
                null,
                to
              ),
              _react2.default.createElement(
                'tr',
                null,
                id
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  couponCode
                )
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(
                    'table',
                    null,
                    _react2.default.createElement(
                      'tbody',
                      null,
                      _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                          'td',
                          { className: "btoTd" },
                          _react2.default.createElement('input', {
                            id: 'fileUpload',
                            type: 'file',
                            name: 'files[]',
                            className: 'inputfile',
                            onChange: function onChange(event) {
                              _this3.storeFile(event, C);
                            },
                            accept: 'image/jpeg, image/bmp' }),
                          _react2.default.createElement(
                            'label',
                            { htmlFor: 'fileUpload' },
                            _react2.default.createElement(_ExtendedButton2.default, {
                              Id: "btoChoose",
                              Usable: true,
                              Text: _Vas2.default.getText("Labels", "ChooseFile")
                            })
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          ), document.getElementById('uploadFields' + this.state.Id));
        } else {
          _reactDom2.default.render(_react2.default.createElement(
            'table',
            null,
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { colSpan: 2 },
                  _react2.default.createElement(_Textfield2.default, {
                    AppURL: _Vas2.default.ApplicationUrl,
                    Value: C["Name"],
                    Width: 220,
                    Id: "Text",
                    Editable: false,
                    Label: _Vas2.default.getText("Labels", "CertificationType") })
                )
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(
                    'div',
                    { style: { margin: '10px', fileSize: '14px' } },
                    _react2.default.createElement(
                      'b',
                      null,
                      _Vas2.default.getText("Titles", "Note"),
                      ': '
                    ),
                    _react2.default.createElement(
                      'i',
                      null,
                      C["Description"]
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'tr',
                null,
                from
              ),
              _react2.default.createElement(
                'tr',
                null,
                to
              ),
              _react2.default.createElement(
                'tr',
                null,
                id
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  couponCode
                )
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(
                    'table',
                    null,
                    _react2.default.createElement(
                      'tbody',
                      null,
                      _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                          'td',
                          { className: "btoTd" },
                          _react2.default.createElement('input', {
                            id: 'fileUpload',
                            type: 'file',
                            name: 'files[]',
                            className: 'inputfile',
                            onChange: function onChange(event) {
                              _this3.storeFile(event, C);
                            },
                            accept: 'image/*,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf' }),
                          _react2.default.createElement(
                            'label',
                            { htmlFor: 'fileUpload' },
                            _react2.default.createElement(_ExtendedButton2.default, {
                              Id: "btoChoose",
                              Usable: true,
                              Text: _Vas2.default.getText("Labels", "ChooseFile")
                            })
                          )
                        )
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { colSpan: 2 },
                  _react2.default.createElement('br', null),
                  _Vas2.default.getText("Labels", "ValidDocumentFormat")
                )
              )
            )
          ), document.getElementById('uploadFields' + this.state.Id));
        }
        this.setState({ FileText: FileText });
      } else {
        _reactDom2.default.render(_react2.default.createElement(
          'table',
          null,
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                couponCode
              )
            )
          )
        ), document.getElementById('uploadFields' + this.state.Id));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var exist = false;
      var vas = false;
      var fileName = '';
      var key = '';
      var found = 0;
      if (this.state.C) {
        for (var i = 0; i < this.state.ExistConfirm.length; i++) {
          if (this.state.ExistConfirm[i].Name === this.state.C["Name"]) {
            exist = true;
            found++;
            vas = this.state.ExistConfirm[i].VAS;
            fileName = this.state.ExistConfirm[i].FileName;
            key = this.state.ExistConfirm[i].Key;
          } else {
            if (this.state.ExistConfirm[i].CouponCode === true && this.state.C["CouponCode"] === true) {
              exist = true;
              found++;
            }
          }
        }

        var text = '';

        if (this.state.C["CouponCode"] === true) {
          text = _Vas2.default.getText("Labels", "Unternehmenscode");
        }
        if (exist === true) {
          if (vas === true) {
            return _react2.default.createElement(
              'tr',
              { key: this.state.C["Name"], id: this.state.Id, ref: this.textInput },
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(
                  'table',
                  null,
                  _react2.default.createElement(
                    'tbody',
                    null,
                    _react2.default.createElement(
                      'tr',
                      null,
                      _react2.default.createElement(
                        'td',
                        { colSpan: 3 },
                        _react2.default.createElement(
                          'h5',
                          null,
                          text
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'tr',
                      null,
                      _react2.default.createElement(
                        'td',
                        { style: { width: '200px' } },
                        _react2.default.createElement(
                          'div',
                          { className: "ConfirmationLabel" },
                          this.state.C["Name"]
                        )
                      ),
                      _react2.default.createElement('td', null),
                      _react2.default.createElement(
                        'td',
                        null,
                        _react2.default.createElement(_Icon2.default, {
                          Name: "Done",
                          Size: 24,
                          Color: "green",
                          Align: "left",
                          Tooltip: _Vas2.default.getText[("Tooltips", "StillUploaded")] })
                      )
                    )
                  )
                )
              )
            );
          } else {
            return _react2.default.createElement(
              'tr',
              { key: this.state.C["Name"], id: this.state.Id, ref: this.textInput },
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(
                  'table',
                  null,
                  _react2.default.createElement(
                    'tbody',
                    null,
                    _react2.default.createElement(
                      'tr',
                      null,
                      _react2.default.createElement(
                        'td',
                        { colSpan: 3 },
                        _react2.default.createElement(
                          'h5',
                          null,
                          text
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'tr',
                      null,
                      _react2.default.createElement(
                        'td',
                        { style: { width: '200px' } },
                        _react2.default.createElement(
                          'div',
                          { className: "ConfirmationLabel" },
                          this.state.C["Name"]
                        )
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        fileName
                      ),
                      _react2.default.createElement('td', null),
                      _react2.default.createElement(
                        'td',
                        null,
                        _react2.default.createElement(_Icon2.default, {
                          Name: "Delete",
                          Size: 24,
                          Color: "black",
                          Align: "left",
                          OnClick: function OnClick() {
                            _this4.removeCertificate(key);
                          },
                          Tooltip: _Vas2.default.getText("Tooltips", "RemoveVerification") })
                      )
                    )
                  )
                )
              )
            );
          }
        } else {

          return _react2.default.createElement(
            'tr',
            { key: this.state.C["Name"], id: this.state.Id, ref: this.textInput },
            _react2.default.createElement(
              'td',
              null,
              _react2.default.createElement(
                'table',
                null,
                _react2.default.createElement(
                  'tbody',
                  null,
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      { colSpan: 3 },
                      _react2.default.createElement(
                        'h5',
                        null,
                        text
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      { style: { width: '200px' } },
                      _react2.default.createElement(
                        'div',
                        { className: "ConfirmationLabel" },
                        this.state.C["Name"]
                      )
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      _react2.default.createElement(_ExtendedButton2.default, {
                        Usable: true,
                        Text: _Vas2.default.getText("Labels", "UploadCertificate"),
                        Float: "left",
                        OnClick: function OnClick() {
                          _this4.getUploadFileds(_this4.state.C);
                        } })
                    ),
                    _react2.default.createElement('td', null)
                  ),
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement('td', { colSpan: 3, id: "uploadFields" + this.state.Id })
                  )
                )
              )
            )
          );
        }
      } else {
        return _react2.default.createElement('div', { id: this.state.Id, ref: this.textInput });
      }
    }
  }]);

  return ConfirmationFields;
}(_react.Component);

exports.default = ConfirmationFields;